// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Accordion,
//   AccordionDetails,
//   AccordionSummary,
//   Alert,
//   Badge,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   Divider,
//   FormControl,
//   Grid,
//   IconButton,
//   InputAdornment,
//   MenuItem,
//   Select,
//   Snackbar,
//   Stack,
//   TextField,
//   ToggleButton,
//   ToggleButtonGroup,
//   Typography,
// } from "@mui/material";

// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
// import SearchIcon from "@mui/icons-material/Search";
// import StarIcon from "@mui/icons-material/Star";
// import StorefrontIcon from "@mui/icons-material/Storefront";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import AddRoundedIcon from "@mui/icons-material/AddRounded";
// import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
// import LocalDiningIcon from "@mui/icons-material/LocalDining";

// import { useSearchParams } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";

// import ApiServices from "../../Utils/ApiServices";
// import CartDrawer from "./CartDrawer";

// const brand = {
//   redDeep: "#7A0E0E",
//   red: "#B71C1C",
//   orange: "#E64A19",
//   amber: "#FFB300",
//   amberLight: "#FFC107",
//   cream: "#FFF8F0",
//   charcoal: "#2A1810",
//   gradientPrimary:
//     "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)",
//   gradientAmber:
//     "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)",
//   gradientHero:
//     "linear-gradient(135deg, #2A0A0A 0%, #7A0E0E 35%, #B71C1C 70%, #E64A19 100%)",
// };

// const MotionCard = motion(Card);
// const MotionGridItem = motion(Grid);

// const cardVariants = {
//   hidden: { opacity: 0, y: 30 },
//   show: (i) => ({
//     opacity: 1,
//     y: 0,
//     transition: {
//       delay: i * 0.04,
//       duration: 0.45,
//       ease: [0.22, 1, 0.36, 1],
//     },
//   }),
// };

// const getClientId = (searchParams) =>
//   searchParams.get("client_id") ||
//   searchParams.get("clientId") ||
//   localStorage.getItem("activeClientId") ||
//   process.env.REACT_APP_CLIENT_ID;

// const getLocationId = (searchParams) =>
//   searchParams.get("location_id") || searchParams.get("locationId") || "";

// const getDefaultServiceType = (searchParams) =>
//   searchParams.get("service_type") || "delivery";

// const getCustomerId = () =>
//   localStorage.getItem("customer_id") ||
//   localStorage.getItem("customerId") ||
//   localStorage.getItem("logged_customer_id") ||
//   localStorage.getItem("user_id") ||
//   "";

// const getAccessToken = () => localStorage.getItem("access_token") || "";

// const getDisplayPrice = (item, serviceType, selectedVariantId = null) => {
//   if (selectedVariantId && Array.isArray(item?.variant_groups)) {
//     for (const group of item.variant_groups) {
//       const found = group?.variants?.find((v) => v.id === selectedVariantId);
//       if (found) return found?.pricing?.[serviceType] ?? null;
//     }
//   }

//   if (item?.pricing) return item.pricing?.[serviceType] ?? null;

//   if (Array.isArray(item?.variant_groups)) {
//     const firstAvailableVariant = item.variant_groups
//       .flatMap((group) => group.variants || [])
//       .find((variant) => variant.is_available);

//     return firstAvailableVariant?.pricing?.[serviceType] ?? null;
//   }

//   return null;
// };

// const normalizeMenuResponse = (responseData) => {
//   const raw =
//     responseData?.data?.menu
//       ? responseData.data
//       : responseData?.menu
//       ? responseData
//       : responseData?.results?.menu
//       ? responseData.results
//       : responseData?.result?.menu
//       ? responseData.result
//       : responseData;

//   const sections = Array.isArray(raw?.menu) ? raw.menu : [];

//   return {
//     location_id: raw?.location_id || "",
//     location_name: raw?.location_name || "",
//     menu: sections.map((section) => ({
//       ...section,
//       categories: Array.isArray(section.categories)
//         ? section.categories.map((category) => ({
//             ...category,
//             items: Array.isArray(category.items)
//               ? category.items.map((item) => ({
//                   ...item,
//                   section_id: section.id,
//                   section_name: section.name,
//                   category_id: category.id,
//                   category_name: category.name,
//                   tags: Array.isArray(item.tags) ? item.tags : [],
//                   ingredients: Array.isArray(item.ingredients)
//                     ? item.ingredients
//                     : [],
//                   variant_groups: Array.isArray(item.variant_groups)
//                     ? item.variant_groups.map((group) => ({
//                         ...group,
//                         variants: Array.isArray(group.variants)
//                           ? group.variants
//                           : [],
//                       }))
//                     : [],
//                   direct_variants: Array.isArray(item.direct_variants)
//                     ? item.direct_variants
//                     : [],
//                   sub_items: Array.isArray(item.sub_items) ? item.sub_items : [],
//                 }))
//               : [],
//           }))
//         : [],
//     })),
//   };
// };

// const FoodieBackdrop = () => (
//   <Box
//     aria-hidden
//     sx={{
//       position: "fixed",
//       inset: 0,
//       zIndex: 0,
//       pointerEvents: "none",
//       overflow: "hidden",
//       background:
//         "radial-gradient(1200px 600px at -10% -10%, rgba(255,179,0,0.18), transparent 60%), radial-gradient(900px 500px at 110% 0%, rgba(230,74,25,0.18), transparent 60%), linear-gradient(180deg, #FFF8F0 0%, #FFFFFF 40%, #FFF3E6 100%)",
//     }}
//   />
// );

// const MenuDetailsPage = () => {
//   const [searchParams, setSearchParams] = useSearchParams();

//   const clientId = useMemo(() => getClientId(searchParams), [searchParams]);
//   const initialLocationId = useMemo(() => getLocationId(searchParams), [searchParams]);
//   const initialServiceType = useMemo(
//     () => getDefaultServiceType(searchParams),
//     [searchParams]
//   );

//   const isLoggedIn = localStorage.getItem("is_logged") === "true";
//   const customerId = getCustomerId();
//   const token = getAccessToken();

//   const [branches, setBranches] = useState([]);
//   const [selectedBranchId, setSelectedBranchId] = useState(initialLocationId);
//   const [serviceType, setServiceType] = useState(initialServiceType);
//   const [menuData, setMenuData] = useState(null);

//   const [loadingBranches, setLoadingBranches] = useState(true);
//   const [loadingMenu, setLoadingMenu] = useState(false);

//   const [searchText, setSearchText] = useState("");
//   const [ingredientSearchText, setIngredientSearchText] = useState("");
//   const [excludedIngredients, setExcludedIngredients] = useState([]);

//   const [cartOpen, setCartOpen] = useState(false);
//   const [cartRefreshKey, setCartRefreshKey] = useState(0);
//   const [cartItemCount, setCartItemCount] = useState(
//     Number(localStorage.getItem("cart_item_count") || 0)
//   );

//   const [variantDialog, setVariantDialog] = useState({
//     open: false,
//     item: null,
//     selectedVariantId: null,
//     selectedVariantName: "",
//     quantity: 1,
//     notes: "",
//   });

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   const showMessage = (message, severity = "info") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const fetchCartCount = async () => {
//     if (!isLoggedIn || !customerId) {
//       setCartItemCount(0);
//       localStorage.setItem("cart_item_count", "0");
//       return;
//     }

//     try {
//       const response = await ApiServices.get(`/api/v1/customers/${customerId}/cart/`, {
//         Authorization: `Bearer ${token}`,
//       });

//       const count =
//         response?.data?.items?.reduce(
//           (acc, item) => acc + Number(item.quantity || 0),
//           0
//         ) || 0;

//       setCartItemCount(count);
//       localStorage.setItem("cart_item_count", String(count));
//     } catch {
//       setCartItemCount(0);
//       localStorage.setItem("cart_item_count", "0");
//     }
//   };

//   const fetchBranches = async () => {
//     try {
//       setLoadingBranches(true);

//       const response = await ApiServices.get(`/api/v1/clients/${clientId}/locations/`);
//       const data = Array.isArray(response?.data) ? response.data : [];
//       const activeBranches = data.filter((item) => item.is_active !== false);

//       setBranches(activeBranches);

//       if (!selectedBranchId && activeBranches.length > 0) {
//         const primaryBranch =
//           activeBranches.find((item) => item.is_primary) || activeBranches[0];

//         setSelectedBranchId(primaryBranch.id);
//       }
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to load branches.",
//         "error"
//       );
//     } finally {
//       setLoadingBranches(false);
//     }
//   };

//   const fetchMenu = async (locationId) => {
//     if (!locationId || !clientId) return;

//     try {
//       setLoadingMenu(true);

//       const response = await ApiServices.get(
//         `/api/v1/menu/${clientId}/locations/${locationId}/tree/`
//       );

//       const normalized = normalizeMenuResponse(response?.data);
//       setMenuData(normalized);
//     } catch (error) {
//       showMessage(error?.response?.data?.detail || "Failed to load menu.", "error");
//       setMenuData(null);
//     } finally {
//       setLoadingMenu(false);
//     }
//   };

//   useEffect(() => {
//     if (clientId) fetchBranches();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [clientId]);

//   useEffect(() => {
//     if (selectedBranchId) {
//       fetchMenu(selectedBranchId);

//       setSearchParams({
//         client_id: clientId,
//         location_id: selectedBranchId,
//         service_type: serviceType,
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedBranchId, serviceType, clientId]);

//   useEffect(() => {
//     fetchCartCount();

//     const handler = (event) => {
//       setCartItemCount(Number(event?.detail?.count || 0));
//     };

//     window.addEventListener("cart-count-updated", handler);

//     return () => window.removeEventListener("cart-count-updated", handler);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cartRefreshKey, isLoggedIn, customerId]);

//   const allIngredients = useMemo(() => {
//     const sections = Array.isArray(menuData?.menu) ? menuData.menu : [];
//     const map = new Map();

//     sections.forEach((section) => {
//       (section.categories || []).forEach((category) => {
//         (category.items || []).forEach((item) => {
//           (item.ingredients || []).forEach((ingredient) => {
//             const clean = String(ingredient || "").trim();
//             if (clean && !map.has(clean.toLowerCase())) {
//               map.set(clean.toLowerCase(), clean);
//             }
//           });
//         });
//       });
//     });

//     return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
//   }, [menuData]);

//   const ingredientSuggestions = useMemo(() => {
//     const query = ingredientSearchText.trim().toLowerCase();

//     return allIngredients
//       .filter((ingredient) => {
//         const lower = ingredient.toLowerCase();

//         if (excludedIngredients.some((item) => item.toLowerCase() === lower)) {
//           return false;
//         }

//         if (!query) return true;

//         return lower.includes(query);
//       })
//       .slice(0, 12);
//   }, [allIngredients, ingredientSearchText, excludedIngredients]);

//   const addExcludedIngredient = (ingredient) => {
//     const clean = String(ingredient || "").trim();
//     if (!clean) return;

//     setExcludedIngredients((prev) =>
//       prev.some((item) => item.toLowerCase() === clean.toLowerCase())
//         ? prev
//         : [...prev, clean]
//     );

//     setIngredientSearchText("");
//   };

//   const removeExcludedIngredient = (ingredient) => {
//     setExcludedIngredients((prev) =>
//       prev.filter((item) => item.toLowerCase() !== ingredient.toLowerCase())
//     );
//   };

//   const itemHasExcludedIngredient = (item) => {
//     if (!excludedIngredients.length) return false;

//     const itemIngredients = (item.ingredients || []).map((ingredient) =>
//       String(ingredient || "").trim().toLowerCase()
//     );

//     return excludedIngredients.some((excluded) =>
//       itemIngredients.includes(String(excluded || "").trim().toLowerCase())
//     );
//   };

//   const filteredSections = useMemo(() => {
//     const sections = Array.isArray(menuData?.menu) ? menuData.menu : [];
//     const query = searchText.trim().toLowerCase();

//     return sections
//       .map((section) => {
//         const categories = (section.categories || [])
//           .map((category) => {
//             const items = (category.items || []).filter((item) => {
//               if (itemHasExcludedIngredient(item)) return false;

//               if (!query) return true;

//               const haystack = [
//                 section.name,
//                 category.name,
//                 item.name,
//                 item.description,
//                 item.badge,
//                 ...(item.tags || []),
//                 ...(item.ingredients || []),
//               ]
//                 .filter(Boolean)
//                 .join(" ")
//                 .toLowerCase();

//               return haystack.includes(query);
//             });

//             return { ...category, items };
//           })
//           .filter((category) => category.items.length > 0);

//         return { ...section, categories };
//       })
//       .filter((section) => section.categories.length > 0);
//   }, [menuData, searchText, excludedIngredients]);

//   const selectedBranch = useMemo(
//     () => branches.find((branch) => branch.id === selectedBranchId) || null,
//     [branches, selectedBranchId]
//   );

//   const openVariantDialog = (item) => {
//     let defaultVariantId = null;
//     let defaultVariantName = "";

//     if (Array.isArray(item?.variant_groups) && item.variant_groups.length) {
//       const firstGroup = item.variant_groups[0];
//       const firstAvailable =
//         firstGroup?.variants?.find((variant) => variant.is_available) ||
//         firstGroup?.variants?.[0];

//       if (firstAvailable) {
//         defaultVariantId = firstAvailable.id;
//         defaultVariantName = firstAvailable.name;
//       }
//     }

//     setVariantDialog({
//       open: true,
//       item,
//       selectedVariantId: defaultVariantId,
//       selectedVariantName: defaultVariantName,
//       quantity: 1,
//       notes: "",
//     });
//   };

//   const closeVariantDialog = () => {
//     setVariantDialog({
//       open: false,
//       item: null,
//       selectedVariantId: null,
//       selectedVariantName: "",
//       quantity: 1,
//       notes: "",
//     });
//   };

//   const addToCart = async () => {
//     if (!isLoggedIn) {
//       showMessage("Please login or signup to add items to cart.", "warning");
//       return;
//     }

//     if (!customerId) {
//       showMessage("Customer id not found in session storage.", "error");
//       return;
//     }

//     const item = variantDialog.item;
//     if (!item) return;

//     try {
//       await ApiServices.post(
//         `/api/v1/customers/${customerId}/cart/items/`,
//         {
//           item_id: item.id,
//           category_id: item.category_id,
//           item_name: item.name,
//           variant_id: variantDialog.selectedVariantId || null,
//           variant_name: variantDialog.selectedVariantName || "",
//           quantity: Number(variantDialog.quantity || 1),
//           notes: variantDialog.notes || "",
//         },
//         { Authorization: `Bearer ${token}` }
//       );

//       const cartId = localStorage.getItem("cart_id");

//       if (cartId) {
//         try {
//           await ApiServices.patch(
//             `/api/v1/customers/${customerId}/cart/${cartId}/`,
//             {
//               service_type: serviceType,
//               location_id: selectedBranchId,
//             },
//             { Authorization: `Bearer ${token}` }
//           );
//         } catch {}
//       }

//       setCartRefreshKey((prev) => prev + 1);
//       await fetchCartCount();
//       closeVariantDialog();
//       showMessage("Item added to cart.", "success");
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to add item to cart.",
//         "error"
//       );
//     }
//   };

//   const renderItemCard = (item, categoryId, index) => {
//     const displayPrice = getDisplayPrice(item, serviceType);
//     const hasVariants = item?.variant_groups?.some(
//       (group) => Array.isArray(group.variants) && group.variants.length > 0
//     );

//     const imageUrl =
//       item.image ||
//       "https://images.unsplash.com/photo-1513104890138-7c749659a591?q=80&w=1200&auto=format&fit=crop";

//     return (
//       <MotionGridItem
//         item
//         xs={12}
//         sm={6}
//         lg={4}
//         key={item.id}
//         custom={index}
//         initial="hidden"
//         whileInView="show"
//         viewport={{ once: true, amount: 0.1 }}
//         variants={cardVariants}
//       >
//         <motion.div whileHover={{ y: -8, scale: 1.01 }}>
//           <Card
//             sx={{
//               height: "100%",
//               borderRadius: 5,
//               overflow: "hidden",
//               background: "linear-gradient(180deg, #ffffff 0%, #FFF8F0 100%)",
//               border: "1px solid rgba(183,28,28,0.08)",
//               boxShadow: "0 14px 40px rgba(122,14,14,0.10)",
//             }}
//           >
//             <Box sx={{ position: "relative", height: 220, overflow: "hidden" }}>
//               <Box
//                 sx={{
//                   position: "absolute",
//                   inset: 0,
//                   backgroundImage: `url("${imageUrl}")`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                 }}
//               />

//               <Box
//                 sx={{
//                   position: "absolute",
//                   inset: 0,
//                   background:
//                     "linear-gradient(180deg, transparent 40%, rgba(42,10,10,0.55) 100%)",
//                 }}
//               />

//               <Stack
//                 direction="row"
//                 spacing={1}
//                 sx={{
//                   position: "absolute",
//                   top: 12,
//                   left: 12,
//                   right: 12,
//                   zIndex: 2,
//                 }}
//               >
//                 <Chip
//                   size="small"
//                   label={item.is_veg ? "Veg" : "Non-Veg"}
//                   sx={{
//                     bgcolor: "rgba(255,255,255,0.95)",
//                     color: brand.charcoal,
//                     fontWeight: 700,
//                     border: `1px solid ${item.is_veg ? "#16a34a" : "#dc2626"}`,
//                   }}
//                 />

//                 {item.badge ? (
//                   <Chip
//                     size="small"
//                     label={item.badge}
//                     sx={{
//                       background: brand.gradientAmber,
//                       color: brand.redDeep,
//                       fontWeight: 800,
//                     }}
//                   />
//                 ) : null}
//               </Stack>

//               {displayPrice !== null && (
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     bottom: 12,
//                     right: 12,
//                     zIndex: 2,
//                     px: 1.5,
//                     py: 0.6,
//                     borderRadius: 999,
//                     background: brand.gradientPrimary,
//                     color: "#fff",
//                     fontWeight: 800,
//                     fontSize: 14,
//                   }}
//                 >
//                   {hasVariants ? "from " : ""}${Number(displayPrice).toFixed(2)}
//                 </Box>
//               )}
//             </Box>

//             <CardContent sx={{ p: 2.5 }}>
//               <Stack spacing={1.5}>
//                 <Box>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontFamily: "'Playfair Display', Georgia, serif",
//                       fontWeight: 800,
//                       color: brand.charcoal,
//                       lineHeight: 1.15,
//                     }}
//                   >
//                     {item.name}
//                   </Typography>

//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                     sx={{
//                       mt: 0.6,
//                       minHeight: 38,
//                       display: "-webkit-box",
//                       WebkitLineClamp: 2,
//                       WebkitBoxOrient: "vertical",
//                       overflow: "hidden",
//                     }}
//                   >
//                     {item.description || "Freshly prepared, made with love."}
//                   </Typography>
//                 </Box>

//                 <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                   <Chip
//                     icon={
//                       <StarIcon
//                         sx={{
//                           fontSize: "16px !important",
//                           color: "#FFB300 !important",
//                         }}
//                       />
//                     }
//                     size="small"
//                     label={`${item.rating || "0"} (${item.rating_count || 0})`}
//                     sx={{ fontWeight: 700, bgcolor: "#FFF8E1" }}
//                   />

//                   <Chip
//                     icon={<AccessTimeIcon sx={{ fontSize: "16px !important" }} />}
//                     size="small"
//                     label={`${item.prep_time_minutes || 0} min`}
//                     sx={{ bgcolor: "#FFF3E0" }}
//                   />

//                   <Chip
//                     icon={
//                       <LocalFireDepartmentIcon
//                         sx={{
//                           fontSize: "16px !important",
//                           color: "#E64A19 !important",
//                         }}
//                       />
//                     }
//                     size="small"
//                     label={`${item.calories || 0} cal`}
//                     sx={{ bgcolor: "#FFEBE5" }}
//                   />
//                 </Stack>

//                 {!!item.tags?.length && (
//                   <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                     {item.tags.slice(0, 3).map((tag) => (
//                       <Chip
//                         key={tag}
//                         size="small"
//                         label={tag}
//                         sx={{
//                           bgcolor: "rgba(183,28,28,0.06)",
//                           color: brand.redDeep,
//                           fontWeight: 600,
//                         }}
//                       />
//                     ))}
//                   </Stack>
//                 )}

//                 {!!item.ingredients?.length && (
//                   <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap>
//                     {item.ingredients.slice(0, 4).map((ingredient) => (
//                       <Chip
//                         key={ingredient}
//                         size="small"
//                         label={ingredient}
//                         variant="outlined"
//                         sx={{
//                           fontSize: 11,
//                           height: 22,
//                           color: "text.secondary",
//                         }}
//                       />
//                     ))}
//                   </Stack>
//                 )}

//                 <Divider
//                   sx={{
//                     borderStyle: "dashed",
//                     borderColor: "rgba(183,28,28,0.15)",
//                   }}
//                 />

//                 <Stack direction="row" justifyContent="space-between" alignItems="center">
//                   <Box>
//                     <Typography
//                       variant="caption"
//                       color="text.secondary"
//                       sx={{ letterSpacing: 1 }}
//                     >
//                       {hasVariants ? "STARTS FROM" : "PRICE"}
//                     </Typography>

//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontWeight: 900,
//                         background: brand.gradientPrimary,
//                         WebkitBackgroundClip: "text",
//                         WebkitTextFillColor: "transparent",
//                         lineHeight: 1.1,
//                       }}
//                     >
//                       {displayPrice !== null
//                         ? `$${Number(displayPrice).toFixed(2)}`
//                         : "—"}
//                     </Typography>
//                   </Box>

//                   <Button
//                     variant="contained"
//                     disabled={!item.is_available}
//                     startIcon={<AddShoppingCartIcon />}
//                     onClick={() => openVariantDialog({ ...item, category_id: categoryId })}
//                     sx={{
//                       borderRadius: 999,
//                       fontWeight: 800,
//                       px: 2.4,
//                       py: 1,
//                       textTransform: "none",
//                       color: "#fff",
//                       background: brand.gradientPrimary,
//                       boxShadow: "0 10px 24px rgba(183,28,28,0.4)",
//                       "&:hover": { background: brand.gradientPrimary },
//                     }}
//                   >
//                     {hasVariants ? "Select" : "Add"}
//                   </Button>
//                 </Stack>
//               </Stack>
//             </CardContent>
//           </Card>
//         </motion.div>
//       </MotionGridItem>
//     );
//   };

//   return (
//     <Box sx={{ position: "relative", minHeight: "100vh", pb: 10 }}>
//       <FoodieBackdrop />

//       <Box sx={{ position: "relative", zIndex: 1 }}>
//         <Box
//           sx={{
//             background: brand.gradientHero,
//             color: "#fff",
//             py: { xs: 5, md: 8 },
//             mb: 5,
//             position: "relative",
//             overflow: "hidden",
//           }}
//         >
//           <Container maxWidth="xl">
//             <Grid container spacing={3} alignItems="center">
//               <Grid item xs={12} md={8}>
//                 <Stack spacing={1.5}>
//                   <Stack direction="row" spacing={1.2} alignItems="center">
//                     <Box
//                       sx={{
//                         width: 38,
//                         height: 38,
//                         borderRadius: "50%",
//                         display: "grid",
//                         placeItems: "center",
//                         background: brand.gradientAmber,
//                       }}
//                     >
//                       <StorefrontIcon sx={{ color: brand.redDeep, fontSize: 20 }} />
//                     </Box>

//                     <Typography
//                       sx={{
//                         letterSpacing: 3,
//                         textTransform: "uppercase",
//                         fontSize: 12,
//                         opacity: 0.9,
//                         fontWeight: 600,
//                       }}
//                     >
//                       Browse the Menu
//                     </Typography>
//                   </Stack>

//                   <Typography
//                     sx={{
//                       fontFamily: "'Playfair Display', Georgia, serif",
//                       fontWeight: 900,
//                       fontSize: { xs: 36, md: 56 },
//                       lineHeight: 1.05,
//                     }}
//                   >
//                     {menuData?.location_name ||
//                       selectedBranch?.name ||
//                       "Crafted Flavors, Served Fresh"}
//                   </Typography>

//                   {selectedBranch ? (
//                     <Stack direction="row" spacing={1} alignItems="center">
//                       <LocationOnIcon fontSize="small" sx={{ color: brand.amber }} />
//                       <Typography variant="body2" sx={{ opacity: 0.92 }}>
//                         {[
//                           selectedBranch.address_line1,
//                           selectedBranch.street,
//                           selectedBranch.city,
//                           selectedBranch.state,
//                         ]
//                           .filter(Boolean)
//                           .join(", ")}
//                       </Typography>
//                     </Stack>
//                   ) : null}
//                 </Stack>
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <Card
//                   sx={{
//                     borderRadius: 5,
//                     bgcolor: "rgba(255,255,255,0.10)",
//                     border: "1px solid rgba(255,255,255,0.18)",
//                     backdropFilter: "blur(20px)",
//                   }}
//                 >
//                   <CardContent sx={{ p: 2.5 }}>
//                     <Stack spacing={2}>
//                       <TextField
//                         fullWidth
//                         placeholder="Search pizza, fries, shakes..."
//                         value={searchText}
//                         onChange={(event) => setSearchText(event.target.value)}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon sx={{ color: "#fff" }} />
//                             </InputAdornment>
//                           ),
//                         }}
//                         sx={{
//                           "& .MuiOutlinedInput-root": {
//                             color: "#fff",
//                             borderRadius: 999,
//                             bgcolor: "rgba(255,255,255,0.08)",
//                             "& fieldset": {
//                               borderColor: "rgba(255,255,255,0.3)",
//                             },
//                           },
//                           "& input::placeholder": {
//                             color: "rgba(255,255,255,0.85)",
//                             opacity: 1,
//                           },
//                         }}
//                       />

//                       <Button
//                         fullWidth
//                         variant="contained"
//                         startIcon={
//                           <Badge
//                             badgeContent={cartItemCount}
//                             showZero={false}
//                             sx={{
//                               "& .MuiBadge-badge": {
//                                 bgcolor: brand.red,
//                                 color: "#fff",
//                                 fontWeight: 800,
//                               },
//                             }}
//                           >
//                             <ShoppingCartIcon />
//                           </Badge>
//                         }
//                         onClick={() => setCartOpen(true)}
//                         sx={{
//                           borderRadius: 999,
//                           py: 1.4,
//                           fontWeight: 800,
//                           textTransform: "none",
//                           color: brand.redDeep,
//                           background: brand.gradientAmber,
//                           "&:hover": { background: brand.gradientAmber },
//                         }}
//                       >
//                         {cartItemCount > 0 ? `View Cart · ${cartItemCount}` : "Open Cart"}
//                       </Button>
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Container>
//         </Box>

//         <Container maxWidth="xl">
//           <MotionCard
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             sx={{
//               borderRadius: 5,
//               mb: 3,
//               border: "1px solid rgba(183,28,28,0.08)",
//               boxShadow: "0 14px 36px rgba(122,14,14,0.08)",
//               background: "linear-gradient(180deg, #ffffff 0%, #FFFAF3 100%)",
//             }}
//           >
//             <CardContent sx={{ p: 3 }}>
//               <Grid container spacing={2.5} alignItems="center">
//                 <Grid item xs={12} md={6}>
//                   <Typography
//                     variant="overline"
//                     sx={{ color: brand.red, fontWeight: 800, letterSpacing: 2 }}
//                   >
//                     Branch
//                   </Typography>

//                   <FormControl fullWidth sx={{ mt: 0.5 }}>
//                     <Select
//                       value={selectedBranchId || ""}
//                       onChange={(event) => setSelectedBranchId(event.target.value)}
//                       displayEmpty
//                       sx={{ borderRadius: 999, bgcolor: "#fff" }}
//                     >
//                       {branches.map((branch) => (
//                         <MenuItem key={branch.id} value={branch.id}>
//                           {branch.name}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Typography
//                     variant="overline"
//                     sx={{ color: brand.red, fontWeight: 800, letterSpacing: 2 }}
//                   >
//                     Service
//                   </Typography>

//                   <ToggleButtonGroup
//                     fullWidth
//                     value={serviceType}
//                     exclusive
//                     onChange={(event, value) => value && setServiceType(value)}
//                     sx={{
//                       mt: 0.5,
//                       bgcolor: "#fff",
//                       borderRadius: 999,
//                       p: 0.6,
//                       border: "1px solid rgba(183,28,28,0.18)",
//                       "& .MuiToggleButton-root": {
//                         border: "none !important",
//                         borderRadius: "999px !important",
//                         textTransform: "capitalize",
//                         fontWeight: 700,
//                         "&.Mui-selected": {
//                           color: "#fff",
//                           background: brand.gradientPrimary,
//                         },
//                       },
//                     }}
//                   >
//                     <ToggleButton value="pickup">Pickup</ToggleButton>
//                     <ToggleButton value="delivery">Delivery</ToggleButton>
//                     <ToggleButton value="dine_in">Dine In</ToggleButton>
//                   </ToggleButtonGroup>
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </MotionCard>

//           <MotionCard
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             sx={{
//               borderRadius: 5,
//               mb: 4,
//               border: "1px solid rgba(183,28,28,0.08)",
//               boxShadow: "0 14px 36px rgba(122,14,14,0.08)",
//               background: "linear-gradient(180deg, #ffffff 0%, #FFFAF3 100%)",
//             }}
//           >
//             <CardContent sx={{ p: 3 }}>
//               <Stack spacing={2}>
//                 <Stack direction="row" spacing={1.5} alignItems="center">
//                   <Box
//                     sx={{
//                       width: 44,
//                       height: 44,
//                       borderRadius: "50%",
//                       display: "grid",
//                       placeItems: "center",
//                       background: brand.gradientAmber,
//                     }}
//                   >
//                     <FilterAltIcon sx={{ color: brand.redDeep }} />
//                   </Box>

//                   <Box>
//                     <Typography
//                       sx={{
//                         fontFamily: "'Playfair Display', Georgia, serif",
//                         fontWeight: 800,
//                         fontSize: 20,
//                         color: brand.charcoal,
//                       }}
//                     >
//                       Avoid Ingredients
//                     </Typography>

//                     <Typography variant="body2" color="text.secondary">
//                       Select ingredients to hide matching menu items.
//                     </Typography>
//                   </Box>
//                 </Stack>

//                 <TextField
//                   fullWidth
//                   value={ingredientSearchText}
//                   onChange={(event) => setIngredientSearchText(event.target.value)}
//                   placeholder="Search ingredients to avoid..."
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon sx={{ color: brand.red }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       borderRadius: 999,
//                       bgcolor: "#fff",
//                     },
//                   }}
//                 />

//                 {!!ingredientSuggestions.length && (
//                   <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                     <AnimatePresence>
//                       {ingredientSuggestions.map((ingredient) => (
//                         <motion.div
//                           key={ingredient}
//                           layout
//                           initial={{ opacity: 0, scale: 0.8 }}
//                           animate={{ opacity: 1, scale: 1 }}
//                           exit={{ opacity: 0, scale: 0.8 }}
//                         >
//                           <Chip
//                             label={ingredient}
//                             onClick={() => addExcludedIngredient(ingredient)}
//                             sx={{
//                               fontWeight: 700,
//                               bgcolor: "#FFF3E0",
//                               color: brand.redDeep,
//                               cursor: "pointer",
//                             }}
//                           />
//                         </motion.div>
//                       ))}
//                     </AnimatePresence>
//                   </Stack>
//                 )}

//                 {!!excludedIngredients.length && (
//                   <>
//                     <Divider />

//                     <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                       {excludedIngredients.map((ingredient) => (
//                         <Chip
//                           key={ingredient}
//                           label={`No ${ingredient}`}
//                           onDelete={() => removeExcludedIngredient(ingredient)}
//                           sx={{
//                             fontWeight: 700,
//                             bgcolor: "#FEE2E2",
//                             color: "#991B1B",
//                           }}
//                         />
//                       ))}

//                       <Button
//                         size="small"
//                         onClick={() => {
//                           setExcludedIngredients([]);
//                           setIngredientSearchText("");
//                         }}
//                       >
//                         Clear All
//                       </Button>
//                     </Stack>
//                   </>
//                 )}
//               </Stack>
//             </CardContent>
//           </MotionCard>

//           {loadingBranches || loadingMenu ? (
//             <Box
//               sx={{
//                 minHeight: 360,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 2,
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CircularProgress sx={{ color: brand.red }} />
//               <Typography color="text.secondary">Loading menu...</Typography>
//             </Box>
//           ) : !filteredSections.length ? (
//             <Alert severity="info" sx={{ borderRadius: 4, fontWeight: 600 }}>
//               No menu items match your search or filters.
//             </Alert>
//           ) : (
//             <Stack spacing={3}>
//               {filteredSections.map((section, sectionIndex) => (
//                 <motion.div
//                   key={section.id}
//                   initial={{ opacity: 0, y: 24 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true, amount: 0.1 }}
//                   transition={{ duration: 0.5, delay: sectionIndex * 0.05 }}
//                 >
//                   <Accordion
//                     defaultExpanded
//                     sx={{
//                       borderRadius: "20px !important",
//                       overflow: "hidden",
//                       border: "1px solid rgba(183,28,28,0.08)",
//                       boxShadow: "0 14px 36px rgba(122,14,14,0.08)",
//                       "&:before": { display: "none" },
//                       bgcolor: "#fff",
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ExpandMoreIcon sx={{ color: "#fff", fontSize: 30 }} />}
//                       sx={{
//                         background: section.is_veg
//                           ? "linear-gradient(135deg, #1B5E20 0%, #2E7D32 50%, #43A047 100%)"
//                           : brand.gradientPrimary,
//                         color: "#fff",
//                         minHeight: 88,
//                         px: 3,
//                       }}
//                     >
//                       <Stack direction="row" spacing={2} alignItems="center">
//                         <Box
//                           sx={{
//                             width: 56,
//                             height: 56,
//                             borderRadius: "50%",
//                             display: "grid",
//                             placeItems: "center",
//                             background: brand.gradientAmber,
//                           }}
//                         >
//                           <RestaurantMenuIcon
//                             sx={{ color: brand.redDeep, fontSize: 28 }}
//                           />
//                         </Box>

//                         <Box>
//                           <Typography
//                             sx={{
//                               fontFamily: "'Playfair Display', Georgia, serif",
//                               fontWeight: 800,
//                               fontSize: { xs: 22, md: 28 },
//                               lineHeight: 1.1,
//                             }}
//                           >
//                             {section.name}
//                           </Typography>

//                           <Stack direction="row" spacing={1} sx={{ mt: 0.6 }}>
//                             <Chip
//                               size="small"
//                               label={section.is_veg ? "Pure Veg" : "Non-Veg"}
//                               sx={{
//                                 fontWeight: 700,
//                                 bgcolor: "rgba(255,255,255,0.18)",
//                                 color: "#fff",
//                               }}
//                             />

//                             <Chip
//                               size="small"
//                               icon={
//                                 <LocalDiningIcon
//                                   sx={{
//                                     fontSize: "14px !important",
//                                     color: "#fff !important",
//                                   }}
//                                 />
//                               }
//                               label={`${section.categories?.length || 0} Categories`}
//                               sx={{
//                                 fontWeight: 700,
//                                 bgcolor: "rgba(255,255,255,0.18)",
//                                 color: "#fff",
//                               }}
//                             />
//                           </Stack>
//                         </Box>
//                       </Stack>
//                     </AccordionSummary>

//                     <AccordionDetails sx={{ p: { xs: 2, md: 4 }, bgcolor: "#FFFCF7" }}>
//                       <Stack spacing={5}>
//                         {(section.categories || []).map((category) => (
//                           <Box key={category.id}>
//                             <Stack
//                               direction="row"
//                               justifyContent="space-between"
//                               alignItems="center"
//                               sx={{ mb: 2.5 }}
//                             >
//                               <Box sx={{ position: "relative", pl: 2.5 }}>
//                                 <Box
//                                   sx={{
//                                     position: "absolute",
//                                     left: 0,
//                                     top: 4,
//                                     bottom: 4,
//                                     width: 5,
//                                     borderRadius: 5,
//                                     background: brand.gradientAmber,
//                                   }}
//                                 />

//                                 <Typography
//                                   sx={{
//                                     fontFamily: "'Playfair Display', Georgia, serif",
//                                     fontWeight: 800,
//                                     fontSize: { xs: 20, md: 24 },
//                                     color: brand.charcoal,
//                                     lineHeight: 1.1,
//                                   }}
//                                 >
//                                   {category.name}
//                                 </Typography>

//                                 {category.description ? (
//                                   <Typography
//                                     variant="body2"
//                                     color="text.secondary"
//                                     sx={{ mt: 0.4 }}
//                                   >
//                                     {category.description}
//                                   </Typography>
//                                 ) : null}
//                               </Box>

//                               <Chip
//                                 label={`${category.items?.length || 0} items`}
//                                 sx={{
//                                   bgcolor: "#FFF3E0",
//                                   color: brand.redDeep,
//                                   fontWeight: 700,
//                                 }}
//                               />
//                             </Stack>

//                             <Grid container spacing={3}>
//                               {(category.items || []).map((item, index) =>
//                                 renderItemCard(item, category.id, index)
//                               )}
//                             </Grid>
//                           </Box>
//                         ))}
//                       </Stack>
//                     </AccordionDetails>
//                   </Accordion>
//                 </motion.div>
//               ))}
//             </Stack>
//           )}
//         </Container>
//       </Box>

//       <Dialog
//         open={variantDialog.open}
//         onClose={closeVariantDialog}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: 5,
//             overflow: "hidden",
//             background: "linear-gradient(180deg, #ffffff 0%, #FFFAF3 100%)",
//           },
//         }}
//       >
//         <Box sx={{ background: brand.gradientPrimary, color: "#fff", px: 3, py: 2.5 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box>
//               <Typography
//                 sx={{
//                   fontFamily: "'Playfair Display', Georgia, serif",
//                   fontWeight: 800,
//                   fontSize: 24,
//                   lineHeight: 1.1,
//                 }}
//               >
//                 {variantDialog.item?.name || "Add Item"}
//               </Typography>

//               <Typography variant="caption" sx={{ opacity: 0.9, letterSpacing: 1 }}>
//                 CUSTOMIZE YOUR ORDER
//               </Typography>
//             </Box>

//             <IconButton onClick={closeVariantDialog} sx={{ color: "#fff" }}>
//               <CloseRoundedIcon />
//             </IconButton>
//           </Stack>
//         </Box>

//         <DialogContent sx={{ pt: 3 }}>
//           <Stack spacing={2.5}>
//             {variantDialog.item?.description ? (
//               <Typography variant="body2" color="text.secondary">
//                 {variantDialog.item.description}
//               </Typography>
//             ) : null}

//             {!!variantDialog.item?.variant_groups?.length &&
//               variantDialog.item.variant_groups.map((group) => (
//                 <Box key={group.id}>
//                   <Typography
//                     variant="overline"
//                     sx={{ fontWeight: 800, color: brand.red, letterSpacing: 2 }}
//                   >
//                     {group.name}
//                   </Typography>

//                   <FormControl fullWidth sx={{ mt: 0.5 }}>
//                     <Select
//                       value={variantDialog.selectedVariantId || ""}
//                       onChange={(event) => {
//                         const selected = group.variants.find(
//                           (variant) => variant.id === event.target.value
//                         );

//                         setVariantDialog((prev) => ({
//                           ...prev,
//                           selectedVariantId: event.target.value,
//                           selectedVariantName: selected?.name || "",
//                         }));
//                       }}
//                       sx={{ borderRadius: 999, bgcolor: "#fff" }}
//                     >
//                       {(group.variants || []).map((variant) => (
//                         <MenuItem
//                           key={variant.id}
//                           value={variant.id}
//                           disabled={!variant.is_available}
//                         >
//                           {variant.name} — $
//                           {Number(variant?.pricing?.[serviceType] ?? 0).toFixed(2)}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               ))}

//             <Box>
//               <Typography
//                 variant="overline"
//                 sx={{ fontWeight: 800, color: brand.red, letterSpacing: 2 }}
//               >
//                 Quantity
//               </Typography>

//               <Stack
//                 direction="row"
//                 alignItems="center"
//                 spacing={2}
//                 sx={{
//                   mt: 0.5,
//                   bgcolor: "#fff",
//                   borderRadius: 999,
//                   px: 1,
//                   py: 0.5,
//                   border: "1px solid rgba(183,28,28,0.2)",
//                   width: "fit-content",
//                 }}
//               >
//                 <IconButton
//                   onClick={() =>
//                     setVariantDialog((prev) => ({
//                       ...prev,
//                       quantity: Math.max(1, Number(prev.quantity) - 1),
//                     }))
//                   }
//                 >
//                   <RemoveRoundedIcon />
//                 </IconButton>

//                 <Typography
//                   sx={{
//                     fontWeight: 800,
//                     fontSize: 20,
//                     minWidth: 32,
//                     textAlign: "center",
//                   }}
//                 >
//                   {variantDialog.quantity}
//                 </Typography>

//                 <IconButton
//                   onClick={() =>
//                     setVariantDialog((prev) => ({
//                       ...prev,
//                       quantity: Number(prev.quantity) + 1,
//                     }))
//                   }
//                   sx={{
//                     color: "#fff",
//                     background: brand.gradientPrimary,
//                     "&:hover": { background: brand.gradientPrimary, opacity: 0.9 },
//                   }}
//                 >
//                   <AddRoundedIcon />
//                 </IconButton>
//               </Stack>
//             </Box>

//             <Box>
//               <Typography
//                 variant="overline"
//                 sx={{ fontWeight: 800, color: brand.red, letterSpacing: 2 }}
//               >
//                 Special Notes
//               </Typography>

//               <TextField
//                 placeholder="Extra cheese, no onion, less spicy..."
//                 value={variantDialog.notes}
//                 onChange={(event) =>
//                   setVariantDialog((prev) => ({
//                     ...prev,
//                     notes: event.target.value,
//                   }))
//                 }
//                 fullWidth
//                 multiline
//                 minRows={3}
//                 sx={{
//                   mt: 0.5,
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 3,
//                     bgcolor: "#fff",
//                   },
//                 }}
//               />
//             </Box>

//             <Card
//               sx={{
//                 borderRadius: 4,
//                 background: brand.gradientHero,
//                 color: "#fff",
//               }}
//             >
//               <CardContent>
//                 <Stack direction="row" justifyContent="space-between" alignItems="center">
//                   <Box>
//                     <Typography variant="caption" sx={{ opacity: 0.85, letterSpacing: 2 }}>
//                       TOTAL · {variantDialog.quantity}×
//                     </Typography>

//                     <Typography
//                       sx={{
//                         fontFamily: "'Playfair Display', Georgia, serif",
//                         fontWeight: 900,
//                         fontSize: 32,
//                         lineHeight: 1,
//                         mt: 0.5,
//                       }}
//                     >
//                       $
//                       {(
//                         Number(
//                           getDisplayPrice(
//                             variantDialog.item,
//                             serviceType,
//                             variantDialog.selectedVariantId
//                           ) || 0
//                         ) * Number(variantDialog.quantity || 1)
//                       ).toFixed(2)}
//                     </Typography>
//                   </Box>

//                   <LocalFireDepartmentIcon
//                     sx={{ fontSize: 56, color: brand.amber, opacity: 0.85 }}
//                   />
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Stack>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             variant="outlined"
//             onClick={closeVariantDialog}
//             sx={{
//               borderRadius: 999,
//               fontWeight: 700,
//               textTransform: "none",
//               px: 3,
//               borderColor: "rgba(183,28,28,0.3)",
//               color: brand.red,
//             }}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             onClick={addToCart}
//             startIcon={<AddShoppingCartIcon />}
//             sx={{
//               borderRadius: 999,
//               fontWeight: 800,
//               textTransform: "none",
//               px: 3,
//               py: 1.1,
//               background: brand.gradientPrimary,
//               "&:hover": { background: brand.gradientPrimary },
//             }}
//           >
//             Add to Cart
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <CartDrawer
//         open={cartOpen}
//         onClose={() => setCartOpen(false)}
//         clientId={clientId}
//         locationId={selectedBranchId}
//         serviceType={serviceType}
//         refreshTrigger={cartRefreshKey}
//         mode="drawer"
//         onCartCountChange={setCartItemCount}
//       />

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           variant="filled"
//           severity={snackbar.severity}
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           sx={{ borderRadius: 3, fontWeight: 600 }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default MenuDetailsPage;


import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import { useSearchParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import ApiServices from "../../Utils/ApiServices";
import CartDrawer from "./CartDrawer";
import MenuOfferSections from "./MenuOfferSections";
import MenuItemSections from "./MenuItemSections";

export const brand = {
  redDeep: "#7A0E0E",
  red: "#B71C1C",
  orange: "#E64A19",
  amber: "#FFB300",
  amberLight: "#FFC107",
  cream: "#FFF8F0",
  charcoal: "#2A1810",
  gradientPrimary:
    "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)",
  gradientAmber:
    "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)",
  gradientHero:
    "linear-gradient(135deg, #2A0A0A 0%, #7A0E0E 35%, #B71C1C 70%, #E64A19 100%)",
};

export const getImageUrl = (image) => {
  if (!image) return "";
  if (String(image).startsWith("http://") || String(image).startsWith("https://")) {
    return image;
  }
  return `https://riteseo.com${String(image).startsWith("/") ? image : `/${image}`}`;
};

export const money = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return `$${Number(value).toFixed(2)}`;
};

export const getDisplayPrice = (item, serviceType, selectedVariantId = null) => {
  if (selectedVariantId && Array.isArray(item?.variant_groups)) {
    for (const group of item.variant_groups) {
      const found = group?.variants?.find((v) => v.id === selectedVariantId);
      if (found) return found?.pricing?.[serviceType] ?? null;
    }
  }

  if (item?.pricing) return item.pricing?.[serviceType] ?? null;

  if (Array.isArray(item?.variant_groups)) {
    const firstAvailableVariant = item.variant_groups
      .flatMap((group) => group.variants || [])
      .find((variant) => variant.is_available);

    return firstAvailableVariant?.pricing?.[serviceType] ?? null;
  }

  return null;
};

const getClientId = (searchParams) =>
  searchParams.get("client_id") ||
  searchParams.get("clientId") ||
  localStorage.getItem("activeClientId") ||
  process.env.REACT_APP_CLIENT_ID;

const getLocationId = (searchParams) =>
  searchParams.get("location_id") || searchParams.get("locationId") || "";

const getDefaultServiceType = (searchParams) =>
  searchParams.get("service_type") || "delivery";

const getCustomerId = () =>
  localStorage.getItem("customer_id") ||
  localStorage.getItem("customerId") ||
  localStorage.getItem("logged_customer_id") ||
  localStorage.getItem("user_id") ||
  "";

const getAccessToken = () => localStorage.getItem("access_token") || "";

const getErrorText = (error, fallback) =>
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

const listFromResponse = (response, keys = []) => {
  const data = response?.data ?? response;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;

  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key];
    if (Array.isArray(data?.results?.[key])) return data.results[key];
    if (Array.isArray(data?.data?.[key])) return data.data[key];
  }

  return [];
};

const sortByDisplayOrder = (items = []) =>
  [...items].sort((a, b) => Number(a?.display_order ?? 9999) - Number(b?.display_order ?? 9999));

const normalizeMenuItem = (item, section, category) => ({
  ...item,
  section_id: section?.id || item?.section_id || item?.food_type || "",
  section_name: section?.name || item?.section_name || item?.food_type_name || "",
  category_id: category?.id || item?.category_id || item?.category || "",
  category_name: category?.name || item?.category_name || "",
  tags: Array.isArray(item?.tags) ? item.tags : [],
  ingredients: Array.isArray(item?.ingredients) ? item.ingredients : [],
  variant_groups: Array.isArray(item?.variant_groups)
    ? sortByDisplayOrder(item.variant_groups).map((group) => ({
        ...group,
        variants: Array.isArray(group?.variants)
          ? sortByDisplayOrder(group.variants)
          : [],
      }))
    : [],
  direct_variants: Array.isArray(item?.direct_variants) ? item.direct_variants : [],
  sub_items: Array.isArray(item?.sub_items) ? item.sub_items : [],
});

const normalizeMenuResponse = (responseData) => {
  let data = responseData?.data ?? responseData;

  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      data = {};
    }
  }

  const raw =
    data?.menu && Array.isArray(data.menu)
      ? data
      : data?.results?.menu && Array.isArray(data.results.menu)
      ? data.results
      : data?.result?.menu && Array.isArray(data.result.menu)
      ? data.result
      : data?.data?.menu && Array.isArray(data.data.menu)
      ? data.data
      : data;

  const sections = Array.isArray(raw?.menu)
    ? raw.menu
    : Array.isArray(raw?.food_types)
    ? raw.food_types
    : [];

  return {
    location_id: raw?.location_id || raw?.location?.id || "",
    location_name: raw?.location_name || raw?.location?.name || "",
    menu: sortByDisplayOrder(sections)
      .filter((section) => section?.is_available !== false)
      .map((section) => ({
        ...section,
        categories: sortByDisplayOrder(Array.isArray(section?.categories) ? section.categories : [])
          .filter((category) => category?.is_available !== false)
          .map((category) => ({
            ...category,
            items: sortByDisplayOrder(Array.isArray(category?.items) ? category.items : [])
              .filter((item) => item?.is_available !== false)
              .map((item) => normalizeMenuItem(item, section, category)),
          }))
          .filter((category) => category.items.length > 0),
      }))
      .filter((section) => section.categories.length > 0),
    embeddedCombos: Array.isArray(raw?.combos) ? sortByDisplayOrder(raw.combos) : [],
    embeddedSpecials: Array.isArray(raw?.active_specials) ? sortByDisplayOrder(raw.active_specials) : [],
  };
};

const FoodieBackdrop = () => (
  <Box
    aria-hidden
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: 0,
      pointerEvents: "none",
      overflow: "hidden",
      background:
        "radial-gradient(1200px 600px at -10% -10%, rgba(255,179,0,0.18), transparent 60%), radial-gradient(900px 500px at 110% 0%, rgba(230,74,25,0.18), transparent 60%), linear-gradient(180deg, #FFF8F0 0%, #FFFFFF 40%, #FFF3E6 100%)",
    }}
  />
);

const MenuDetailsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const clientId = useMemo(() => getClientId(searchParams), [searchParams]);
  const initialLocationId = useMemo(() => getLocationId(searchParams), [searchParams]);
  const initialServiceType = useMemo(
    () => getDefaultServiceType(searchParams),
    [searchParams]
  );

  const isLoggedIn = localStorage.getItem("is_logged") === "true";
  const customerId = getCustomerId();
  const token = getAccessToken();

  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(initialLocationId);
  const [serviceType, setServiceType] = useState(initialServiceType);
  const [menuData, setMenuData] = useState(null);
  const [activeSpecials, setActiveSpecials] = useState([]);
  const [activeCombos, setActiveCombos] = useState([]);

  const [loadingBranches, setLoadingBranches] = useState(true);
  const [loadingMenu, setLoadingMenu] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [ingredientSearchText, setIngredientSearchText] = useState("");
  const [excludedIngredients, setExcludedIngredients] = useState([]);

  const [cartOpen, setCartOpen] = useState(false);
  const [cartRefreshKey, setCartRefreshKey] = useState(0);
  const [cartItemCount, setCartItemCount] = useState(
    Number(localStorage.getItem("cart_item_count") || 0)
  );

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showMessage = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  const fetchCartCount = async () => {
    if (!isLoggedIn || !customerId) {
      setCartItemCount(0);
      localStorage.setItem("cart_item_count", "0");
      return;
    }

    try {
      const response = await ApiServices.get(`/api/v1/customers/${customerId}/cart/`, authHeaders);

      const count =
        response?.data?.items?.reduce(
          (acc, item) => acc + Number(item.quantity || 0),
          0
        ) || 0;

      setCartItemCount(count);
      localStorage.setItem("cart_item_count", String(count));
    } catch {
      setCartItemCount(0);
      localStorage.setItem("cart_item_count", "0");
    }
  };

  const refreshCart = async () => {
    setCartRefreshKey((prev) => prev + 1);
    await fetchCartCount();
  };

  const fetchBranches = async () => {
    try {
      setLoadingBranches(true);

      const response = await ApiServices.get(`/api/v1/clients/${clientId}/locations/`);
      const data = Array.isArray(response?.data) ? response.data : [];
      const activeBranches = data.filter((item) => item.is_active !== false);

      setBranches(activeBranches);

      if (!selectedBranchId && activeBranches.length > 0) {
        const primaryBranch =
          activeBranches.find((item) => item.is_primary) || activeBranches[0];

        setSelectedBranchId(primaryBranch.id);
      }
    } catch (error) {
      showMessage(getErrorText(error, "Failed to load branches."), "error");
    } finally {
      setLoadingBranches(false);
    }
  };

  const fetchMenu = async (locationId) => {
    if (!locationId || !clientId) return;

    try {
      setLoadingMenu(true);

      const menuResponse = await ApiServices.get(
        `/api/v1/menu/${clientId}/locations/${locationId}/tree/`
      );

      const normalized = normalizeMenuResponse(menuResponse);
      setMenuData(normalized);

      let specials = normalized.embeddedSpecials || [];
      let combos = normalized.embeddedCombos || [];

      const [specialsResult, combosResult] = await Promise.allSettled([
        ApiServices.get(`/api/v1/menu/${clientId}/locations/${locationId}/active-specials/`),
        ApiServices.get(`/api/v1/menu/${clientId}/locations/${locationId}/combos/?active=true`),
      ]);

      if (specialsResult.status === "fulfilled") {
        const apiSpecials = listFromResponse(specialsResult.value, ["active_specials", "specials"]);
        if (apiSpecials.length) specials = apiSpecials;
      }

      if (combosResult.status === "fulfilled") {
        const apiCombos = listFromResponse(combosResult.value, ["combos", "active_combos"]);
        if (apiCombos.length) combos = apiCombos;
      }

      setActiveSpecials(sortByDisplayOrder(specials || []).filter((item) => item.is_active !== false));
      setActiveCombos(sortByDisplayOrder(combos || []).filter((item) => item.is_available !== false));
    } catch (error) {
      showMessage(getErrorText(error, "Failed to load menu."), "error");
      setMenuData(null);
      setActiveSpecials([]);
      setActiveCombos([]);
    } finally {
      setLoadingMenu(false);
    }
  };

  useEffect(() => {
    if (clientId) fetchBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  useEffect(() => {
    if (selectedBranchId) {
      fetchMenu(selectedBranchId);

      setSearchParams({
        client_id: clientId,
        location_id: selectedBranchId,
        service_type: serviceType,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBranchId, serviceType, clientId]);

  useEffect(() => {
    fetchCartCount();

    const handler = (event) => {
      setCartItemCount(Number(event?.detail?.count || 0));
    };

    window.addEventListener("cart-count-updated", handler);

    return () => window.removeEventListener("cart-count-updated", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartRefreshKey, isLoggedIn, customerId]);

  const allIngredients = useMemo(() => {
    const sections = Array.isArray(menuData?.menu) ? menuData.menu : [];
    const map = new Map();

    sections.forEach((section) => {
      (section.categories || []).forEach((category) => {
        (category.items || []).forEach((item) => {
          (item.ingredients || []).forEach((ingredient) => {
            const clean = String(ingredient || "").trim();
            if (clean && !map.has(clean.toLowerCase())) {
              map.set(clean.toLowerCase(), clean);
            }
          });
        });
      });
    });

    return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
  }, [menuData]);

  const ingredientSuggestions = useMemo(() => {
    const query = ingredientSearchText.trim().toLowerCase();

    return allIngredients
      .filter((ingredient) => {
        const lower = ingredient.toLowerCase();

        if (excludedIngredients.some((item) => item.toLowerCase() === lower)) {
          return false;
        }

        if (!query) return true;

        return lower.includes(query);
      })
      .slice(0, 12);
  }, [allIngredients, ingredientSearchText, excludedIngredients]);

  const addExcludedIngredient = (ingredient) => {
    const clean = String(ingredient || "").trim();
    if (!clean) return;

    setExcludedIngredients((prev) =>
      prev.some((item) => item.toLowerCase() === clean.toLowerCase())
        ? prev
        : [...prev, clean]
    );

    setIngredientSearchText("");
  };

  const removeExcludedIngredient = (ingredient) => {
    setExcludedIngredients((prev) =>
      prev.filter((item) => item.toLowerCase() !== ingredient.toLowerCase())
    );
  };

  const itemHasExcludedIngredient = (item) => {
    if (!excludedIngredients.length) return false;

    const itemIngredients = (item.ingredients || []).map((ingredient) =>
      String(ingredient || "").trim().toLowerCase()
    );

    return excludedIngredients.some((excluded) =>
      itemIngredients.includes(String(excluded || "").trim().toLowerCase())
    );
  };

  const filteredSections = useMemo(() => {
    const sections = Array.isArray(menuData?.menu) ? menuData.menu : [];
    const query = searchText.trim().toLowerCase();

    return sections
      .map((section) => {
        const categories = (section.categories || [])
          .map((category) => {
            const items = (category.items || []).filter((item) => {
              if (itemHasExcludedIngredient(item)) return false;

              if (!query) return true;

              const haystack = [
                section.name,
                category.name,
                item.name,
                item.description,
                item.badge,
                ...(item.tags || []),
                ...(item.ingredients || []),
              ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

              return haystack.includes(query);
            });

            return { ...category, items };
          })
          .filter((category) => category.items.length > 0);

        return { ...section, categories };
      })
      .filter((section) => section.categories.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuData, searchText, excludedIngredients]);

  const selectedBranch = useMemo(
    () => branches.find((branch) => branch.id === selectedBranchId) || null,
    [branches, selectedBranchId]
  );

  return (
    <Box sx={{ position: "relative", minHeight: "100vh", pb: 10 }}>
      <FoodieBackdrop />

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            background: brand.gradientHero,
            color: "#fff",
            py: { xs: 5, md: 8 },
            mb: 5,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Container maxWidth="xl">
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={8}>
                <Stack spacing={1.5}>
                  <Stack direction="row" spacing={1.2} alignItems="center">
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        display: "grid",
                        placeItems: "center",
                        background: brand.gradientAmber,
                      }}
                    >
                      <StorefrontIcon sx={{ color: brand.redDeep, fontSize: 20 }} />
                    </Box>

                    <Typography
                      sx={{
                        letterSpacing: 3,
                        textTransform: "uppercase",
                        fontSize: 12,
                        opacity: 0.9,
                        fontWeight: 600,
                      }}
                    >
                      Browse the Menu
                    </Typography>
                  </Stack>

                  <Typography
                    sx={{
                      fontFamily: "'Playfair Display', Georgia, serif",
                      fontWeight: 900,
                      fontSize: { xs: 36, md: 56 },
                      lineHeight: 1.05,
                    }}
                  >
                    {menuData?.location_name ||
                      selectedBranch?.name ||
                      "Crafted Flavors, Served Fresh"}
                  </Typography>

                  {selectedBranch ? (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <LocationOnIcon fontSize="small" sx={{ color: brand.amber }} />
                      <Typography variant="body2" sx={{ opacity: 0.92 }}>
                        {[
                          selectedBranch.address_line1,
                          selectedBranch.street,
                          selectedBranch.city,
                          selectedBranch.state,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </Typography>
                    </Stack>
                  ) : null}
                </Stack>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    borderRadius: 5,
                    bgcolor: "rgba(255,255,255,0.10)",
                    border: "1px solid rgba(255,255,255,0.18)",
                    backdropFilter: "blur(20px)",
                  }}
                >
                  <CardContent sx={{ p: 2.5 }}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        placeholder="Search pizza, fries, shakes..."
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ color: "#fff" }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "#fff",
                            borderRadius: 999,
                            bgcolor: "rgba(255,255,255,0.08)",
                            "& fieldset": {
                              borderColor: "rgba(255,255,255,0.3)",
                            },
                          },
                          "& input::placeholder": {
                            color: "rgba(255,255,255,0.85)",
                            opacity: 1,
                          },
                        }}
                      />

                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={
                          <Badge
                            badgeContent={cartItemCount}
                            showZero={false}
                            sx={{
                              "& .MuiBadge-badge": {
                                bgcolor: brand.red,
                                color: "#fff",
                                fontWeight: 800,
                              },
                            }}
                          >
                            <ShoppingCartIcon />
                          </Badge>
                        }
                        onClick={() => setCartOpen(true)}
                        sx={{
                          borderRadius: 999,
                          py: 1.4,
                          fontWeight: 800,
                          textTransform: "none",
                          color: brand.redDeep,
                          background: brand.gradientAmber,
                          "&:hover": { background: brand.gradientAmber },
                        }}
                      >
                        {cartItemCount > 0 ? `View Cart · ${cartItemCount}` : "Open Cart"}
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Container maxWidth="xl">
          <Card
            sx={{
              borderRadius: 5,
              mb: 3,
              border: "1px solid rgba(183,28,28,0.08)",
              boxShadow: "0 14px 36px rgba(122,14,14,0.08)",
              background: "linear-gradient(180deg, #ffffff 0%, #FFFAF3 100%)",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Grid container spacing={2.5} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="overline"
                    sx={{ color: brand.red, fontWeight: 800, letterSpacing: 2 }}
                  >
                    Branch
                  </Typography>

                  <FormControl fullWidth sx={{ mt: 0.5 }}>
                    <Select
                      value={selectedBranchId || ""}
                      onChange={(event) => setSelectedBranchId(event.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 999, bgcolor: "#fff" }}
                    >
                      {branches.map((branch) => (
                        <MenuItem key={branch.id} value={branch.id}>
                          {branch.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    variant="overline"
                    sx={{ color: brand.red, fontWeight: 800, letterSpacing: 2 }}
                  >
                    Service
                  </Typography>

                  <ToggleButtonGroup
                    fullWidth
                    value={serviceType}
                    exclusive
                    onChange={(event, value) => value && setServiceType(value)}
                    sx={{
                      mt: 0.5,
                      bgcolor: "#fff",
                      borderRadius: 999,
                      p: 0.6,
                      border: "1px solid rgba(183,28,28,0.18)",
                      "& .MuiToggleButton-root": {
                        border: "none !important",
                        borderRadius: "999px !important",
                        textTransform: "capitalize",
                        fontWeight: 700,
                        "&.Mui-selected": {
                          color: "#fff",
                          background: brand.gradientPrimary,
                        },
                      },
                    }}
                  >
                    <ToggleButton value="pickup">Pickup</ToggleButton>
                    <ToggleButton value="delivery">Delivery</ToggleButton>
                    <ToggleButton value="dine_in">Dine In</ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card
            sx={{
              borderRadius: 5,
              mb: 4,
              border: "1px solid rgba(183,28,28,0.08)",
              boxShadow: "0 14px 36px rgba(122,14,14,0.08)",
              background: "linear-gradient(180deg, #ffffff 0%, #FFFAF3 100%)",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      display: "grid",
                      placeItems: "center",
                      background: brand.gradientAmber,
                    }}
                  >
                    <FilterAltIcon sx={{ color: brand.redDeep }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "'Playfair Display', Georgia, serif",
                        fontWeight: 800,
                        fontSize: 20,
                        color: brand.charcoal,
                      }}
                    >
                      Avoid Ingredients
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Select ingredients to hide matching menu items.
                    </Typography>
                  </Box>
                </Stack>

                <TextField
                  fullWidth
                  value={ingredientSearchText}
                  onChange={(event) => setIngredientSearchText(event.target.value)}
                  placeholder="Search ingredients to avoid..."
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: brand.red }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 999,
                      bgcolor: "#fff",
                    },
                  }}
                />

                {!!ingredientSuggestions.length && (
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    <AnimatePresence>
                      {ingredientSuggestions.map((ingredient) => (
                        <motion.div
                          key={ingredient}
                          layout
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.8 }}
                        >
                          <Chip
                            label={ingredient}
                            onClick={() => addExcludedIngredient(ingredient)}
                            sx={{
                              fontWeight: 700,
                              bgcolor: "#FFF3E0",
                              color: brand.redDeep,
                              cursor: "pointer",
                            }}
                          />
                        </motion.div>
                      ))}
                    </AnimatePresence>
                  </Stack>
                )}

                {!!excludedIngredients.length && (
                  <>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                      {excludedIngredients.map((ingredient) => (
                        <Chip
                          key={ingredient}
                          label={`No ${ingredient}`}
                          onDelete={() => removeExcludedIngredient(ingredient)}
                          sx={{
                            fontWeight: 700,
                            bgcolor: "#FEE2E2",
                            color: "#991B1B",
                          }}
                        />
                      ))}

                      <Button
                        size="small"
                        onClick={() => {
                          setExcludedIngredients([]);
                          setIngredientSearchText("");
                        }}
                      >
                        Clear All
                      </Button>
                    </Stack>
                  </>
                )}
              </Stack>
            </CardContent>
          </Card>

          <MenuOfferSections
            activeSpecials={activeSpecials}
            activeCombos={activeCombos}
            loading={loadingBranches || loadingMenu}
            brand={brand}
            serviceType={serviceType}
            customerId={customerId}
            token={token}
            isLoggedIn={isLoggedIn}
            selectedBranchId={selectedBranchId}
            refreshCart={refreshCart}
            showMessage={showMessage}
          />

          {loadingBranches || loadingMenu ? (
            <Box
              sx={{
                minHeight: 360,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress sx={{ color: brand.red }} />
              <Typography color="text.secondary">Loading menu...</Typography>
            </Box>
          ) : (
            <MenuItemSections
              sections={filteredSections}
              brand={brand}
              serviceType={serviceType}
              customerId={customerId}
              token={token}
              isLoggedIn={isLoggedIn}
              selectedBranchId={selectedBranchId}
              refreshCart={refreshCart}
              showMessage={showMessage}
            />
          )}
        </Container>
      </Box>

      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        clientId={clientId}
        locationId={selectedBranchId}
        serviceType={serviceType}
        refreshTrigger={cartRefreshKey}
        mode="drawer"
        onCartCountChange={setCartItemCount}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          variant="filled"
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          sx={{ borderRadius: 3, fontWeight: 600 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default MenuDetailsPage;
